import './App.scss'
import './scss/custom.scss'
import 'react-toastify/dist/ReactToastify.css'
import Routes from './routes'
import { BrowserRouter } from 'react-router-dom'
import Header from './components/organisms/Header'
import Footer from './components/organisms/Common/Footer'

import { UserProvider } from './context/user/UserProvider'
import { ProductProvider } from './context/products/ProductProvider'
import { SiteProvider } from './context/site/SiteProvider'
import { ShowHideProvider } from './context/showhide/ShowHideProvider'
import { ToastContainer } from 'react-toastify'
import { Flip } from 'react-toastify'
import ModalDeadFish from './components/organisms/Common/Modal/ModalDeadFish'
import { CookiesProvider } from 'react-cookie'
import { Helmet } from 'react-helmet'
import { isProline, PROJECT_ID } from './helpers'
import {
  DEFAULT_PL_META_DESCRIPTION,
  DEFAULT_PL_TITLE,
  DEFAULT_WS_META_DESCRIPTION,
  DEFAULT_WS_TITLE,
} from './constants/constants'
import axios, { AxiosRequestConfig } from 'axios'
import authHeader from './context/services/AuthHeader'
import React, { useEffect } from 'react'


const metaDescription = isProline()
  ? DEFAULT_PL_META_DESCRIPTION
  : DEFAULT_WS_META_DESCRIPTION

const title = isProline() ? DEFAULT_PL_TITLE : DEFAULT_WS_TITLE

const addToCart = (productId: string) => {
  const headersValue: AxiosRequestConfig = { headers: authHeader() }
  return axios
    .post(
      '/carts/iadvize-add-to-cart',
      {
        product_model: productId,
        project_id: PROJECT_ID,
      },
      headersValue
    )
    .then(response => response.data)
}

const App = () => {
  useEffect(() => {
    /**
     * Listener for the custom event dispatched from index.html
     * This "wires" the iAdvize SDK to your React logic and PHP backend.
     */
    const iAdvizeAddToCart = async (event: any) => {
      const { productId, resolve, reject } = event.detail


    try {
      const result = await addToCart(productId)

      if (result.success) {
        resolve(true)
      } else {
        resolve(false)
      }
    } catch (error) {
      console.error('iAdvize Cart Error:', error)
      reject(error)
    }
  };

    // Attach the wire
    window.addEventListener(
      'iadvize:addToCart',
      iAdvizeAddToCart as EventListener
    )

    // Cleanup the wire when the component unmounts
    return () => {
      window.removeEventListener(
        'iAdvize:addToCart',
        iAdvizeAddToCart as EventListener
      )
    }
  }, [])

  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={metaDescription} />
      </Helmet>

      <BrowserRouter>
        <CookiesProvider defaultSetOptions={{ path: '/' }}>
          <ShowHideProvider>
            <UserProvider>
              <ProductProvider>
                <SiteProvider>
                  <div className="page_container">
                    <Header />
                    <Routes />
                    <ModalDeadFish />
                    <ToastContainer
                      transition={Flip}
                      theme="colored"
                      autoClose={3000}
                    />
                  </div>
                  <Footer />
                </SiteProvider>
              </ProductProvider>
            </UserProvider>
          </ShowHideProvider>
        </CookiesProvider>
      </BrowserRouter>
    </>
  )
}

export default App